import Vue from "vue";
import axios from "axios";
import { AUTH_ERROR } from "@/store/modules/mutation-types.js";

import VueAxios from "vue-axios";
import router from "../../router";

Vue.use(VueAxios, axios);

export default {
  state: {
    isLoading: false
  },
  getters: {},
  actions: {
    apiGet({ commit, rootState }, params) {
      // state.isLoading = true;
      let elm = document.getElementById("commonAjaxLoading");
      if (elm) {
        elm.style["display"] = "block";
      }
      let url;
      if (params.url.startsWith("http")) {
        if (
          rootState.config.api_method === "https" &&
          !params.url.startsWith("https")
        ) {
          url = params.url.replace("http", rootState.config.api_method);
        } else {
          url = params.url;
        }
      } else {
        url =
          rootState.config.api_method +
          "://" +
          rootState.config.api_server +
          "/" +
          rootState.config.api_version +
          params.url;
      }
      return axios({
        method: "get",
        url: url,
        params: params.data,
        headers: { Authorization: window.localStorage.getItem("access_token") }
      })
        .then(response => {
          // state.isLoading = false;
          let elm = document.getElementById("commonAjaxLoading");
          if (elm) {
            elm.style["display"] = "none";
          }
          return Promise.resolve(response);
        })
        .catch(error => {
          // state.isLoading = false;
          let elm = document.getElementById("commonAjaxLoading");
          if (elm) {
            elm.style["display"] = "none";
          }
          if (
            error.response &&
            error.response.status &&
            error.response.status === 401
          ) {
            commit(AUTH_ERROR);
          }
          return Promise.reject(error);
        });
    },
    apiPost({ commit, rootState }, params) {
      // state.isLoading = true;
      let elm = document.getElementById("commonAjaxLoading");
      if (elm) {
        elm.style["display"] = "block";
      }
      let url = null;
      if (params.url.startsWith("http")) {
        url = params.url;
      } else {
        url =
          rootState.config.api_method +
          "://" +
          rootState.config.api_server +
          "/" +
          rootState.config.api_version +
          params.url;
      }
      return axios({
        method: "post",
        url: url,
        data: params.data,
        headers: { Authorization: window.localStorage.getItem("access_token") }
      })
        .then(response => {
          // state.isLoading = false;
          let elm = document.getElementById("commonAjaxLoading");
          if (elm) {
            elm.style["display"] = "none";
          }
          return Promise.resolve(response);
        })
        .catch(error => {
          // state.isLoading = false;
          let elm = document.getElementById("commonAjaxLoading");
          if (elm) {
            elm.style["display"] = "none";
          }
          if (
            error.response &&
            error.response.status &&
            error.response.status === 401
          ) {
            commit(AUTH_ERROR);
          }
          return Promise.reject(error);
        });
    },
    apiPatch({ commit, rootState }, params) {
      // state.isLoading = true;
      let elm = document.getElementById("commonAjaxLoading");
      if (elm) {
        elm.style["display"] = "block";
      }
      let url = null;
      if (params.url.startsWith("http")) {
        url = params.url;
      } else {
        url =
          rootState.config.api_method +
          "://" +
          rootState.config.api_server +
          "/" +
          rootState.config.api_version +
          params.url;
      }
      return axios({
        method: "patch",
        url: url,
        data: params.data,
        headers: { Authorization: window.localStorage.getItem("access_token") }
      })
        .then(response => {
          // state.isLoading = false;
          let elm = document.getElementById("commonAjaxLoading");
          if (elm) {
            elm.style["display"] = "none";
          }
          return Promise.resolve(response);
        })
        .catch(error => {
          // state.isLoading = false;
          let elm = document.getElementById("commonAjaxLoading");
          if (elm) {
            elm.style["display"] = "none";
          }
          if (
            error.response &&
            error.response.status &&
            error.response.status === 401
          ) {
            commit(AUTH_ERROR);
          }
          return Promise.reject(error);
        });
    },
    apiDelete({ commit, rootState }, params) {
      // state.isLoading = true;
      let elm = document.getElementById("commonAjaxLoading");
      if (elm) {
        elm.style["display"] = "block";
      }
      let url = null;
      if (params.url.startsWith("http")) {
        url = params.url;
      } else {
        url =
          rootState.config.api_method +
          "://" +
          rootState.config.api_server +
          "/" +
          rootState.config.api_version +
          params.url;
      }
      return axios({
        method: "delete",
        url: url,
        data: params.data,
        headers: { Authorization: window.localStorage.getItem("access_token") }
      })
        .then(response => {
          // state.isLoading = false;
          let elm = document.getElementById("commonAjaxLoading");
          if (elm) {
            elm.style["display"] = "none";
          }
          return Promise.resolve(response);
        })
        .catch(error => {
          // state.isLoading = false;
          let elm = document.getElementById("commonAjaxLoading");
          if (elm) {
            elm.style["display"] = "none";
          }
          if (
            error.response &&
            error.response.status &&
            error.response.status === 401
          ) {
            commit(AUTH_ERROR);
          }
          return Promise.reject(error);
        });
    },
    apiBlobDownload({ commit, rootState }, params) {
      // state.isLoading = true;
      let elm = document.getElementById("commonAjaxLoading");
      if (elm) {
        elm.style["display"] = "block";
      }
      let url = null;
      if (params.url.startsWith("http")) {
        url = params.url;
      } else {
        url =
          rootState.config.api_method +
          "://" +
          rootState.config.api_server +
          "/" +
          rootState.config.api_version +
          params.url;
      }
      return axios({
        method: "get",
        url: url,
        params: params.data,
        headers: { Authorization: window.localStorage.getItem("access_token") },
        responseType: "blob"
      })
        .then(response => {
          // state.isLoading = false;
          let elm = document.getElementById("commonAjaxLoading");
          if (elm) {
            elm.style["display"] = "none";
          }
          return Promise.resolve(response);
        })
        .catch(error => {
          // state.isLoading = false;
          let elm = document.getElementById("commonAjaxLoading");
          if (elm) {
            elm.style["display"] = "none";
          }
          if (
            error.response &&
            error.response.status &&
            error.response.status === 401
          ) {
            commit(AUTH_ERROR);
          }
          return Promise.reject(error);
        });
    }
  },
  mutations: {
    [AUTH_ERROR]() {
      window.localStorage.clear();
      window.sessionStorage.clear();
      router.push("/login");
    }
  }
};
